export default "__VITE_ASSET__B8u87OZ7__"